import { AxiosInstance } from "axios";
import { toast } from "react-toastify";

export interface verifyCodeParameters {
  cu_id: string | null;
  v_type: number;
  v_code: string;
}

interface verifyCodeResponse {
  err: string;
  message: string;
  timeout: number;
}

export const verifyCode = async (
  axios: AxiosInstance,
  { cu_id, v_type, v_code }: verifyCodeParameters
) => {
  if (cu_id === null || cu_id === "" || v_code === "") {
    return;
  }
  const requestData = JSON.stringify({
    cu_id,
    v_type,
    v_code,
  });

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };
  try {
    const res = await axios.post<verifyCodeResponse>(
      "api2/Invitation/verifyCode",
      requestData,
      { headers }
    );

    if (!res.data) {
      return {
        err: "9999",
        message: "",
        timeout: Number(process.env.REACT_APP_VERIFY_CODE_TIMEOUT),
      };
    }
    if (res.data.err !== "0000") {
      toast.error(`簡訊驗證:${"(" + res.data.err + ")" + res.data.message}`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    if (res.data.err === "0000") {
      toast.success(`簡訊已驗證成功`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    return res.data;
  } catch (error) {
    return {
      err: "401",
      message: "",
      timeout: Number(process.env.REACT_APP_VERIFY_CODE_TIMEOUT),
    };
  }
};
